import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { routes } from 'const';
import { EventIcon, MailIcon, MoneyIcon } from 'components/elements';
import useFetchInboundMessagesMeta from 'hooks/portal/useFetchInboundMessagesMeta';
import { useOrganization } from 'hooks';

export default () => {
  const { t, i18n } = useTranslation('labels');
  const { unreadCount } = useFetchInboundMessagesMeta();
  const { data: organization } = useOrganization();
  const MenuList = [
    {
      icon: <EventIcon />,
      link: routes.appointments,
      label: t('appointments'),
    },
    {
      icon: <MailIcon />,
      link: routes.messages,
      count: unreadCount,
      label: t('secure_messages'),
    },
  ];

  if (organization.features?.patientPortalInvoices) {
    MenuList.push({
      icon: <MoneyIcon />,
      link: routes.invoices,
      label: t('invoices'),
    });
  }

  const options = useMemo(() => MenuList, [i18n.language, unreadCount]);
  return { data: options };
};
